import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    notFoundContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
    }
});

export default useStyles;